import { Component, OnInit, Input } from '@angular/core';

import { ContextMain } from '../../_models/common/context.main';
import { MainService } from '../../_services/main.service';
import { AuthService } from '../../_services/auth.service';
import { CartService } from '../../_services/cart.service';
import { ShopService } from '../../_services/shop.service';
import { HomeScreenService } from '../../_services/home-screen.service';
import { ShopSoort } from '../../_models/common/shop.soort';

@Component({
  selector: 'app-header-star',
  templateUrl: './header-star.component.html',
  styleUrls: ['./header-star.component.scss']
})
export class HeaderStarComponent implements OnInit {
  @Input() ctx: ContextMain;
  shopSoort = ShopSoort;

  constructor(
    public mainService: MainService,
    public authService: AuthService,
    public cartService: CartService,
    public shopService: ShopService,
    public homeScreenService: HomeScreenService
  ) { }

  ngOnInit() {
  }

}
